module.exports = __webpack_public_path__ + "static/media/FDVA.cc221d88.png";